import KpiCard from "@/components/KpiCard.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import NumberValue from "@/components/tableElements/NumberValue.vue";
import { COLORS } from "@/utils/constants";
import { getDescriptionBasedOnKpiKey } from "@/utils/transformers";
const {
  title,
  detail
} = getDescriptionBasedOnKpiKey("TACOS");
export default {
  name: "TacosCard",
  props: {
    amount: {
      type: Number
    },
    subtitleAmount: {
      type: Number
    },
    percentage: {
      type: Number
    },
    subtitlePercentage: {
      type: Number
    },
    loading: {
      type: Boolean
    },
    percentageColor: {
      type: String
    },
    percentageBgColor: {
      type: String
    }
  },
  components: {
    KpiCard,
    PercentageValue,
    CurrencyValue,
    NumberValue
  },
  data() {
    return {
      COLORS,
      title,
      detail
    };
  }
};